import script from "./AtomUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomUpload.vue?vue&type=script&lang=ts&setup=true"

import "./AtomUpload.vue?vue&type=style&index=0&id=8e432cfc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e432cfc"]])

export default __exports__